"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZLoadingMask = void 0;
const React = __importStar(require("react"));
const ReactDOM = __importStar(require("react-dom"));
const utils_1 = require("../../utils");
exports.ZLoadingMask = (props) => {
    let container = React.useRef(null);
    const [visible, setVisible] = React.useState(false);
    const [dimensions, setDimensions] = React.useState({
        top: 0,
        left: 0,
        height: "100%",
        width: "100%"
    });
    const frameContext = React.useContext(utils_1.FrameContext);
    React.useEffect(() => {
        if (!visible) {
            container.current = frameContext.document.querySelector(props.containerSelector || "");
            if (container.current) {
                const { offsetTop: top, offsetLeft: left, offsetHeight: height, offsetWidth: width } = container.current;
                setDimensions({ top, left, height, width });
                setVisible(true);
            }
        }
    }, [props.containerSelector, visible, frameContext]);
    const { top, left, height, width } = dimensions;
    const loadingPanel = (React.createElement("div", { className: "k-loading-mask", style: {
            top,
            left,
            height,
            width
        } },
        React.createElement("span", { className: "k-loading-text" }, "Loading"),
        React.createElement("div", { className: "k-loading-image" }),
        React.createElement("div", { className: "k-loading-color" })));
    return (container.current &&
        ReactDOM.createPortal(loadingPanel, container.current));
};
//# sourceMappingURL=ZLoadingMask.js.map